// extracted by mini-css-extract-plugin
export default {"back-btn-label":"Testing_back-btn-label__TwFje","btn-back-envirtual-container":"Testing_btn-back-envirtual-container__0ViSd","ddl":"Testing_ddl__01njK"};